// components/Dashboard.js
import React from 'react';

const StaffDashboard = ({ punchedIn, setPunchedIn }) => {
  const currentTime = new Date().toLocaleTimeString('en-US', { 
    hour: '2-digit', 
    minute: '2-digit',
    hour12: true 
  });
  
  const currentDate = new Date().toLocaleDateString('en-US', { 
    weekday: 'long', 
    year: 'numeric', 
    month: 'short', 
    day: 'numeric' 
  });

  const handlePunch = () => {
    setPunchedIn(!punchedIn);
  };

  return (
    <div className="p-4">
      {/* Header */}
      <div className="text-center mb-6">
        <h1 className="text-2xl font-bold text-primary">Stellaris</h1>
        <p className="text-gray-600">Serve More, Stress Less.</p>
        <div className="mt-2">
          <p className="text-lg font-semibold">{currentTime}</p>
          <p className="text-gray-500">{currentDate}</p>
        </div>
      </div>

      {/* Punch In/Out Button */}
      <div className="bg-red-50 rounded-full  p-4 mb-6 text-center">
        <button 
          onClick={handlePunch}
          className={`py-3 rounded-full w-32 h-32 font-bold text-white ${punchedIn ? 'bg-red-500' : 'bg-green-500'}`}
        >
          {punchedIn ? 'PUNCH OUT' : 'PUNCH IN'}
        </button>
        {/* {!punchedIn && <p className="mt-2 text-gray-600">Swipe Right To Punch In</p>} */}
      </div>

      {/* Stats */}
      <div className="grid grid-cols-2 gap-4 mb-6">
        <div className="bg-white border rounded-lg p-4 text-center">
          <p className="text-gray-500 text-sm">Total Working Hrs</p>
          <p className="text-xl font-bold">0.00</p>
        </div>
        <div className="bg-white border rounded-lg p-4 text-center">
          <p className="text-gray-500 text-sm">Salary Due</p>
          <p className="text-xl font-bold">7.0</p>
        </div>
        <div className="bg-white border rounded-lg p-4 text-center">
          <p className="text-gray-500 text-sm">Deduction</p>
          <p className="text-xl font-bold">0.0</p>
        </div>
        <div className="bg-white border rounded-lg p-4 text-center">
          <p className="text-gray-500 text-sm">Allowance</p>
          <p className="text-xl font-bold">7.1</p>
        </div>
      </div>

      {/* Time Period Selector */}
      <div className="flex justify-between mb-6">
        {['Today', '1w', '1m', '3m', '1y'].map((period) => (
          <button 
            key={period}
            className={`px-3 py-1 rounded ${period === 'Today' ? 'bg-primary text-white' : 'bg-gray-200'}`}
          >
            {period}
          </button>
        ))}
      </div>

      {/* Create Ticket Button */}
      <div className="text-center">
        <button className="bg-primary text-white py-3 px-6 rounded-lg font-semibold">
          Create Ticket
        </button>
      </div>
    </div>
  );
};

export default StaffDashboard;